
export const isValidTaxNumber = (taxNumber) => {
  taxNumber += ''
  const firstPart = taxNumber.substring(0, 7)
  const secondPart = taxNumber.substring(7, 8)

  const firstPartValue = parseInt(firstPart)

  if (firstPartValue < 1000000 || firstPartValue > 9999999) {
    return false
  }

  var sumValue = 0
  const maxPonder = 8
  const divider = 11

  for (let i = 0; i < firstPart.length; i++) {
    sumValue += parseInt(firstPart[i]) * (maxPonder - i)
  }

  var remainder = sumValue % divider

  var requiredSecondPart = remainder === 1 ? 0 : divider - remainder

  return parseInt(secondPart) === requiredSecondPart
}
